import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { ClockHistory } from 'react-bootstrap-icons';

import StationLinker from '../components/StationLinker.js';

function StationFloodEventLinker({stationId, urlSlug, startTimestampFormatted, endTimestampFormatted, entryHeightMax, displayIndex = false, highestOnRecord = null}) {

	let ixDisplayerClasses = "d-none";
	let ixDisplayerColSize = 12;
	let itemDisplayerColSize = 12;


	if(displayIndex !== false) {
		ixDisplayerClasses = "";
		ixDisplayerColSize = 2;
		itemDisplayerColSize = 10;
	}


	return <Row>
		<Col xs={12} className="bg-secondary text-white"><b>{startTimestampFormatted} (<i>{Math.floor(100*entryHeightMax)/100}m</i>){(displayIndex === false && highestOnRecord === true) && " [record high]"}</b></Col>
		<Col xs={ixDisplayerColSize} className={ixDisplayerClasses}>
			<span style={{fontSize: "1.3em"}}>{(displayIndex)}</span>
			{highestOnRecord && <br />}
			{highestOnRecord && <span style={{fontSize: "0.7em"}}><b><u>Record</u></b></span>}
		</Col>
		<Col xs={itemDisplayerColSize}>
			<Row>
				<Col xs={12}><b>Event Ends:</b> {endTimestampFormatted}</Col>
				<Col xs={12}>
					<StationLinker stationId={stationId} urlSlug={urlSlug} isHistoricalLink historicalFloodStartTime={startTimestampFormatted}>
						<Button variant="dark" size="sm"><ClockHistory /> View Event</Button>
					</StationLinker>
				</Col>
			</Row>
		</Col>
		<Col xs={12}>
			
		</Col>
	</Row>;
}

export default StationFloodEventLinker;